export default __webpack_public_path__ + "static/media/nodejs.34523405.png";